import {
  ApolloClient,
  ApolloLink,
  createHttpLink,
  gql,
  InMemoryCache,
  Observable,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
export * from './stats';
export * from './conversations';
export * from './payment';
export * from './config';
export * from './audiences';
export * from './forms';
import { onError } from '@apollo/client/link/error';
import { REFRESH_TOKEN } from './auth';

const httpLink = createHttpLink({
  uri: `${import.meta.env.VITE_API_URL}/api`,
});

const publicHttpLink = createHttpLink({
  uri: `${import.meta.env.VITE_API_URL}/public`,
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('accessToken');
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

export const publicClient = new ApolloClient({
  link: ApolloLink.from([publicHttpLink]),
  cache: new InMemoryCache(),
});

const resetToken = onError(({ networkError, operation, forward }) => {
  if (
    networkError &&
    'statusCode' in networkError &&
    networkError.statusCode === 401
  ) {
    const retryAttempts = operation.getContext().retryAttempts || 0;
    const refreshToken = localStorage.getItem('refreshToken');

    if (retryAttempts > 1 || !refreshToken) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');

      return;
    }

    // Return a new Observable that handles the refresh and retries the operation
    return new Observable((observer) => {
      publicClient
        .mutate({
          mutation: REFRESH_TOKEN,
          variables: {
            data: {
              refresh_token: refreshToken,
            },
          },
        })
        .then((response) => {
          const { data } = response;
          if (data?.refresh_token?.data.accessToken) {
            localStorage.setItem(
              'accessToken',
              data.refresh_token.data.accessToken,
            );
            localStorage.setItem(
              'refreshToken',
              data.refresh_token.data.refreshToken,
            );
            operation.setContext({
              headers: {
                ...operation.getContext().headers,
                authorization: `Bearer ${data.refresh_token.data.accessToken}`,
              },
              retryAttempts: retryAttempts + 1,
            });
            // Retry the operation and forward the results to the observer
            forward(operation).subscribe({
              next: observer.next.bind(observer),
              error: observer.error.bind(observer),
              complete: observer.complete.bind(observer),
            });
          } else {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            observer.error(networkError);

            window.location.href = '/';
          }
        })
        .catch((error) => {
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          observer.error(error);
        });
    });
  }
});

export const apolloClient = new ApolloClient({
  link: ApolloLink.from([authLink, resetToken, httpLink]),
  cache: new InMemoryCache(),
});
